import { render, staticRenderFns } from "./uploadFileDialog.vue?vue&type=template&id=b4f4990e&scoped=true"
import script from "./uploadFileDialog.vue?vue&type=script&lang=js"
export * from "./uploadFileDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f4990e",
  null
  
)

export default component.exports